import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}


// Adicione este código no final do arquivo results-list.js
// ou crie um novo arquivo shuffle-products.js e o inclua no tema

class ProductShuffler extends HTMLElement {
  constructor() {
    super();
    this.shuffleProducts();
  }

  shuffleProducts() {
    const productGrid = this.querySelector('[ref="grid"]') || 
                       this.querySelector('.product-grid') ||
                       this.querySelector('[product-grid-view]');
    
    if (!productGrid) return;

    const products = Array.from(productGrid.querySelectorAll('.product-grid__item'));
    
    if (products.length === 0) return;

    // Algoritmo Fisher-Yates para embaralhar
    const shuffled = this.fisherYatesShuffle([...products]);
    
    // Remove todos os produtos
    products.forEach(product => product.remove());
    
    // Adiciona na ordem embaralhada
    shuffled.forEach(product => productGrid.appendChild(product));
    
    console.log(`✓ ${products.length} produtos embaralhados`);
  }

  fisherYatesShuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
}

customElements.define('product-shuffler', ProductShuffler);

// Auto-inicialização para a seção existente
document.addEventListener('DOMContentLoaded', () => {
  const resultsList = document.querySelector('results-list');
  if (resultsList) {
    const shuffler = new ProductShuffler();
    shuffler.innerHTML = resultsList.innerHTML;
    shuffler.className = resultsList.className;
    
    // Embaralha após carregar
    setTimeout(() => {
      const productGrid = resultsList.querySelector('[ref="grid"]') || 
                         resultsList.querySelector('.product-grid');
      
      if (productGrid) {
        const products = Array.from(productGrid.querySelectorAll('.product-grid__item'));
        const shuffled = fisherYatesShuffle([...products]);
        
        products.forEach(p => p.remove());
        shuffled.forEach(p => productGrid.appendChild(p));
        
        console.log(`✓ ${products.length} produtos embaralhados`);
      }
    }, 100);
  }
});

function fisherYatesShuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}